export const TenantSetupTracker = ({ progress, steps }) => {
  const activeStepIndex = steps.findIndex((step) => !step.completed);
  const isSetupCompleted = progress === 100;

  return (
    <section className="relative overflow-hidden rounded-lg">
      <div className="px-6 py-6">
        {/* Steps */}
        <div className="grid w-full grid-cols-4">
          {steps.map((step, index) => {
            const isCompleted = step.completed;
            const isActive = !isSetupCompleted && index === activeStepIndex;

            return (
              <div
                key={step.id}
                className="relative flex min-w-0 flex-col items-center text-center"
              >
                {/* Connector */}
                {index < steps.length - 1 && (
                  <div
                    className={`absolute left-1/2 top-[35px] z-0 h-[2px] w-full ${
                      isCompleted && steps[index + 1]?.completed
                        ? "bg-[#00C950]"
                        : isCompleted
                          ? "bg-gradient-to-r from-[#00C950] to-white/45"
                          : "bg-white/45"
                    }`}
                  />
                )}

                {/* Circle */}
                <div
                  className={`relative z-10 flex h-[72px] w-[72px] items-center justify-center rounded-full border-2 text-lg font-bold ${
                    isCompleted
                      ? "border-[#00C950] bg-[#176A5D] text-white"
                      : isActive
                        ? "border-[#A8A8A8] bg-[#30485A] text-white"
                        : "border-[#A8A8A8] bg-[#304353] text-white"
                  }`}
                >
                  {step.icon}

                  {isCompleted && (
                    <span className="absolute -right-1 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-[#00C950] text-sm font-bold text-white">
                      ✓
                    </span>
                  )}
                </div>

                {/* Label */}
                <p className="mt-3 min-h-[38px] px-2 text-sm font-semibold leading-[1.25] text-white">
                  Step {step.id}: {step.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};